// Les routes de l'espace du responsable technique (D-093), sous #/rt/… :
//   #/rt/equipes[/seances | /composition[/<catégorie>]]   vue transversale, suivi des séances, composition
//   #/rt/seance/<événement>/<date>                         la séance d'un coach, en lecture, et ton commentaire
//   #/rt/projet[/<tranche> | /theme | /drills]             projet sportif par cycles, thème du mois, drills du club (D-098)
//   #/rt/joueurs[/suivre]  #/rt/joueur/<personne>          évaluations, à suivre, fiche d'un joueur
//   #/rt/coachs  #/rt/coach/<compte>                       encadrement, diplômes, obligations par niveau
import type { Ctx } from './context';
import { renderRtCompo } from './rt-compo';
import { renderRtCoach, renderRtCoaches } from './rt-coaches';
import { renderRtEvaluations, renderRtFollow, renderRtPlayer } from './rt-players';
import { renderRtProject, renderRtTheme } from './rt-project';
import { renderRtDrills } from './rt-drills';
import { renderRtSession, renderRtSessions, renderRtTeams } from './rt-teams';

/** L'onglet du bas d'une route #/rt/… */
export function rtTab(section: string | undefined): string {
  if (section === 'seance') return 'rt-equipes';
  if (section === 'joueur') return 'rt-joueurs';
  if (section === 'coach') return 'rt-coachs';
  return `rt-${section ?? 'equipes'}`;
}

/** Les écrans à segments d'un onglet : pas de « ‹ Retour » ajouté (on y passe d'un segment à l'autre). */
export const rtIsTabPage = (parts: string[]) => ['equipes', 'projet', 'joueurs', 'coachs'].includes(parts[0] ?? '') && !(parts[0] === 'equipes' && parts[1] === 'composition');

export async function renderRt(view: HTMLElement, ctx: Ctx, parts: string[]): Promise<void> {
  const [section, a, b] = parts;
  if (section === 'seance' && a && b) return renderRtSession(view, ctx, a, b);
  if (section === 'projet') return a === 'theme' ? renderRtTheme(view, ctx) : a === 'drills' ? renderRtDrills(view, ctx) : renderRtProject(view, ctx, a);
  if (section === 'joueurs') return a === 'suivre' ? renderRtFollow(view, ctx) : renderRtEvaluations(view, ctx);
  if (section === 'joueur' && a) return renderRtPlayer(view, ctx, a);
  if (section === 'coachs') return renderRtCoaches(view, ctx);
  if (section === 'coach' && a) return renderRtCoach(view, ctx, a);
  if (a === 'seances') return renderRtSessions(view, ctx);
  if (a === 'composition') return renderRtCompo(view, ctx, b);
  return renderRtTeams(view, ctx);
}
